export default {
    WP_PHONE: "79956558637",
  
  };